const mutations = {
    INVOICE_LOADING: state => {
        state.invoiceStatus = "loading";
    },
    UPDATE_PRICE: (state, price) => {
        state.invoiceCart.p_price = parseFloat(price);
    },
    UPDATE_INVOICE_CART: (state, cart) => {
        state.invoiceCart.p_name = cart.name;
        state.invoiceCart.p_price = parseFloat(cart.price);
    },
    RESET_TOTALS: state => {
        state.invoiceCart.p_price = parseFloat(0.0);
    },
    UPDATE_INVOICES: (state, invoices) => {
        state.invoices = invoices;
    },
    INVOICE_SUCCESS: (state, data) => {
        state.invoiceStatus = "success";
        Vue.set(state, "invoices", data.invoices);
        Vue.set(state, "invoicesCount", data.invoices_count);
    },
    INVOICE_CART_SUCCESS: (state, invoice) => {
        state.invoiceStatus = "success";
        Vue.set(state, "invoiceCart", invoice);
    },
    INVOICE_ERROR: (state, err) => {
        let errors = err.error ? err.error : {};

        state.invoiceStatus = "error";
        state.invoiceErrors.record(errors);
    },
    CLEAR_INVOICE_ERROR: state => {
        state.invoiceStatus = "";
        state.invoiceErrors.clear();
    },
    CLEAR_PAYMENT_ERRORS: state => {
        state.paymentStatus = "";
        state.paymentErrors.clear();
    },
    PAYMENT_LOADING: state => {
        state.paymentStatus = "loading";
    },
    PAYMENT_SUCCESS: state => {
        state.paymentStatus = "success";
    },
    PAYMENT_ERROR: (state, err) => {
        let errors = err.error ? err.error : {};

        state.paymentStatus = "error";
        state.paymentErrors.record(errors);
    },
    RESET_STATE: state => {
        Object.assign(state, state.initialState());
    },
};

export default mutations;
